import type { BikeParkMetadata } from "~/lib/api";
import { cn } from "~/lib/utils";
import { Icon, type IconType } from "~/components/ui/icons/icon";
import { Tag } from "~/components/ui/tag";
import { ACCESS_LABELS } from "./bikeParkLabels";

const ACCESS_ICONS: Record<keyof BikeParkMetadata, IconType> = {
  liftAccess: "gondola-lift",
  shuttleAccess: "shuttle-truck",
};

interface BikeParkAccessPillsProps {
  metadata: BikeParkMetadata;
  className?: string;
}

export function BikeParkAccessPills({ metadata, className }: BikeParkAccessPillsProps) {
  const { liftAccess, shuttleAccess } = metadata;

  if (!liftAccess && !shuttleAccess) return null;

  return (
    <div className={cn("flex flex-wrap gap-1.5", className)}>
      {liftAccess && <AccessTag field="liftAccess" />}
      {shuttleAccess && <AccessTag field="shuttleAccess" />}
    </div>
  );
}

function AccessTag({ field }: { field: keyof BikeParkMetadata }) {
  return (
    <Tag>
      <Icon i={ACCESS_ICONS[field]} className="size-3.5" />
      {ACCESS_LABELS[field]}
    </Tag>
  );
}
